// Layouts/MediaLibrary/mediaTypes.ts

export type MediaKind = 'image' | 'pdf' | 'word' | 'excel' | 'other';

export interface MediaUsageCount {
  study: number;
  practical: number;
  total: number;
}

export interface MediaItem {
  id: string;
  title: string;
  file_name: string;
  key: string;
  url: string;
  size: number;
  mime_type: string;
  ext: string;
  type: MediaKind;
  source: 'upload' | 'backfill';
  created_at: string | null;
  usage: MediaUsageCount;
  /** only on upload responses */
  duplicate?: boolean;
}

export interface MediaUsageRow {
  type: 'study' | 'practical';
  id: string;
  title: string;
  course_title: string | null;
  module_title: string | null;
  chapter_title: string | null;
}

export interface MediaItemDetails extends MediaItem {
  usages: MediaUsageRow[];
}

export const MEDIA_ACCEPT = '.pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png';
export const MEDIA_ALLOWED_EXTS = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpg', 'jpeg', 'png'];
export const MEDIA_MAX_FILE_SIZE = 10 * 1024 * 1024;

export const formatMediaSize = (bytes: number): string => {
  if (!bytes) return '0 KB';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.min(sizes.length - 1, Math.floor(Math.log(bytes) / Math.log(k)));
  return `${Math.round((bytes / Math.pow(k, i)) * 10) / 10} ${sizes[i]}`;
};

export const KIND_STYLE: Record<MediaKind, { icon: string; bg: string; color: string; label: string }> = {
  image: { icon: 'pi-image',      bg: '#ecfdf5', color: '#047857', label: 'Image' },
  pdf:   { icon: 'pi-file-pdf',   bg: '#fef2f2', color: '#b91c1c', label: 'PDF' },
  word:  { icon: 'pi-file-word',  bg: '#eff6ff', color: '#1d4ed8', label: 'Word' },
  excel: { icon: 'pi-file-excel', bg: '#f0fdf4', color: '#15803d', label: 'Excel' },
  other: { icon: 'pi-file',       bg: '#f3f4f6', color: '#4b5563', label: 'File' },
};

export const formatMediaDate = (value: string | null): string => {
  if (!value) return '—';
  const d = new Date(value.replace(' ', 'T') + (value.includes('T') ? '' : 'Z'));
  return isNaN(d.getTime()) ? value : d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
};
